import { Alert, VFlow } from 'bold-ui'
import { css } from 'emotion'
import { useAssinaturaContext } from 'hooks/assinatura-eletronica-context/useAssinaturaEletronicaContext'

import { IdadeOrigemAtendimento, InformacoesAdministrativas } from '../../../model/model-historico'
import { HistoricoAtendimentoObservacaoAlert } from './atendimento-observacao/HistoricoAtendimentoObservacaoAlert'
import HistoricoIdadeOrigemAtendimento from './HistoricoIdadeOrigemAtendimento'
import HistoricoInfoAdminPanel from './HistoricoInfoAdminPanel'

interface HistoricoGapPanelProps {
  idadeOrigemAtendimento?: IdadeOrigemAtendimento
  informacoesAdministrativas: InformacoesAdministrativas
  children: React.ReactNode
  isAtendObservacao?: boolean | null
  dataInicioCompartilhamento?: LocalDate
  tipoParticipacaoCidadao?: string
  tipoVisita?: number
}

export default function HistoricoGapPanel({
  idadeOrigemAtendimento,
  children,
  informacoesAdministrativas,
  isAtendObservacao = false,
  dataInicioCompartilhamento,
  tipoParticipacaoCidadao,
  tipoVisita,
}: HistoricoGapPanelProps) {
  const assinaturaContext = useAssinaturaContext()
  const classes = createStyles()

  return (
    <VFlow>
      <VFlow vSpacing={0.5}>
        {isAtendObservacao && <HistoricoAtendimentoObservacaoAlert />}
        {idadeOrigemAtendimento && (
          <HistoricoIdadeOrigemAtendimento
            idadeOrigemAtendimento={idadeOrigemAtendimento}
            isCompartilhamentoCuidado={informacoesAdministrativas.stCuidadoCompartilhado}
            dataInicioCompartilhamento={dataInicioCompartilhamento}
            tipoParticipacaoCidadao={tipoParticipacaoCidadao}
            tipoVisita={tipoVisita}
          />
        )}
        {assinaturaContext?.isAtendimentoAssinado && (
          <Alert inline type='info' styles={{ wrapper: classes.assinaturaAlert }}>
            Os dados exibidos correspondem ao atendimento e não ao documento assinado. Para visualizar o documento
            assinado, faça o download do arquivo.
          </Alert>
        )}
      </VFlow>
      <VFlow vSpacing={0}>
        <VFlow>{children}</VFlow>
        <HistoricoInfoAdminPanel content={informacoesAdministrativas} />
      </VFlow>
    </VFlow>
  )
}

const createStyles = () => ({
  assinaturaAlert: css`
    padding: 0.5rem;
    width: 80%;
  `,
})
